import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button } from '../../../../../../ui';
import { AddIcon, TrashIcon } from '../../../../../../ui/icons/icons';
import inputStyles from '../../../../../../ui/input/input.module.css';
import { SecondaryTypography } from '../../../../../../ui/typography/typography';
import { userSearch } from '../../../../../../utils/api_service/user_api';
import {
  AssessmentUser,
  User,
} from '../../../../../../utils/types/assessment_types';
import styles from './user_search.module.css';

type UserSearchProps = {
  displayInviteModal: (value: boolean) => void;
  assignedUsers: AssessmentUser[];
  addAssessmentUser: (user: User) => void;
};

export const UserSearch = ({
  displayInviteModal,
  assignedUsers,
  addAssessmentUser,
}: UserSearchProps) => {
  const [searchTerm, setSearchTerm] = useState<string>();
  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [isSearchListOpen, setIsSearchListOpen] = useState<boolean>(false);

  useEffect(() => {
    if (searchTerm) {
      userSearch(searchTerm).then((response) => {
        if (response.length > 0) {
          let filteredSearchResult = response;
          assignedUsers.map((user: AssessmentUser) => {
            filteredSearchResult = filteredSearchResult.filter(
              (item: User) => item.email !== user.email,
            );
          });
          setSearchResults(filteredSearchResult);
        } else {
          setSearchResults([]);
        }
      });
    }
  }, [searchTerm]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const removeFromSearchResults = (user: User) => {
    let searchResultsCopy = searchResults;
    if (searchResultsCopy) {
      searchResultsCopy = searchResultsCopy.filter(
        (item) => item.email !== user.email,
      );
      setSearchResults(searchResultsCopy);
    }
  };

  return (
    <div className='space-y-4 flex items-center justify-between'>
      <div className='relative w-full max-w-lg'>
        <input
            type='text'
            placeholder='Search Users'
            onChange={handleChange}
            onClick={() => setIsSearchListOpen(!isSearchListOpen)}
            className='w-full rounded-lg border border-gray-300 px-4 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200'
        />
        { isSearchListOpen && searchResults?.length > 0 && (
          <div className='absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg max-h-60 overflow-y-auto'>
            { searchResults.map((user: User) => (
              <div
                  key={user.email}
                  className='cursor-pointer px-4 py-2 hover:bg-blue-50 transition-colors'
                  onClick={() => {
                    addAssessmentUser(user);
                    removeFromSearchResults(user);
                  }}
              >
                <SecondaryTypography.Small>
                  { user.firstName } { user.lastName }
                </SecondaryTypography.Small>
              </div>
            )) }
          </div>
        ) }
      </div>

      <div className='flex flex-wrap gap-3'>
        <Button
            variant='secondary'
            label='Invite Candidate'
            icon={<AddIcon />}
            onClick={() => displayInviteModal(true)}
        />
        <Button
            variant='secondary'
            label='Activate Access'
            hasIcon
            icon={<TrashIcon />}
            onClick={() => {}}
        />
        <Button
            variant='secondary'
            label='Disable Access'
            icon={<TrashIcon />}
            onClick={() => {}}
        />
        <Button
            variant='primary'
            label='Remove Candidate'
            icon={<TrashIcon />}
            onClick={() => {}}
        />
      </div>
    </div>
  );
};
